import { render } from "./App.vue?vue&type=template&id=2c7a9928&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=2c7a9928&scoped=true&lang=css"

import exportComponent from "/Users/hansteve/Desktop/work/qingshui/qingshui_home/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c7a9928"]])

export default __exports__